import { Component, OnInit } from "@angular/core";

import { Router, ActivatedRoute } from "@angular/router";

import { ServiceService } from "../../services/service.service";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"]
})
export class SidemenuComponent implements OnInit {
  sideObj = [];
  modules = [];
  sideLinkedObj = [];
  error: boolean = false;
  validation: boolean = false;
  formSubmission: boolean = false;
  formData = new FormData();
  apiResponse: boolean = false;
  activeMenu: string = "";
  newbusiness: boolean = false;
  mybusiness: boolean = false;
  other: boolean = false;
  fleetstatus: boolean = false;
  dispatchLite: boolean = false;

  waitinglist: boolean = false;
  roomtpe = 7; //only used for lab and diagonestic center
  linkedbusiness: boolean = false;
  administration: boolean = false;
  dashboard: boolean = false;
  statitionInventory: boolean = false;

  settings;
  submenu: string = "";
  submenulinked: string = "";
  userrole = [];
  usertype: string;
  user: any;
  displayLite: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService
  ) {
    this.activeMenu = localStorage.getItem("activemenu");
    // this.submenu = localStorage.getItem("submenu");
    // this.submenulinked = localStorage.getItem("submenulinked");
    // this.usertype = localStorage.getItem("usertype");
    // this.settings = JSON.parse(localStorage.getItem("settings"));

    this.user = JSON.parse(localStorage.getItem('user'));

    if (this.activeMenu == "newbusiness") {
      this.newbusiness = !this.newbusiness;
    } else if (this.activeMenu == "mybusiness") {
      this.mybusiness = !this.mybusiness;
    } else if (this.activeMenu == "linkedbusiness") {
      this.linkedbusiness = !this.linkedbusiness;
    } else if (this.activeMenu == "waitinglist") {
      this.waitinglist = !this.waitinglist;
    } else if (this.activeMenu === "administration") {
      this.administration = !this.administration;
    } else if (this.activeMenu === "dashboard") {
      this.dashboard = !this.dashboard;
    } else if (this.activeMenu == "statitioninventory") {
      this.statitionInventory = !this.statitionInventory;
    } else if (this.activeMenu === 'fleetstatus') {
      this.fleetstatus = !this.fleetstatus;
    }
  }

  ngOnInit() {
    if (localStorage.getItem('user_scac') == "jomr") {
      this.displayLite = true;
    }

    this.service.fetchCurrentUserModules().subscribe(modules => {
      this.modules = modules;
    })
  }

  validateSideMenuVisibility(itemName: string) {
    var role = this.user && this.user.user && this.user.user.role && this.user.user.role.role;

    if (role == 'ROLE_SUPER_ADMIN' || itemName == "dashboard") {
      return true;
    }

    if (role == 'ROLE_TENANT_ADMIN' && (
      (itemName == "administration") || ((itemName == "fleetStatus"))
      || itemName == "dashboard" || itemName == "emergency-bol" 
      || itemName == "dispatchLite" || itemName == "details-dashboard" || itemName == "paper-work"
      || itemName == "wait-time-out" || itemName == "tenantDeviceControls"
    )) {
      return true;
    }
    let user = localStorage.getItem("user");
    let userObj = JSON.parse(user);
    let email = userObj.user.email;
    if ((role == 'ROLE_FTP_IMPORT' || role == 'ROLE_WHO_OWNS_IT') && (itemName == "administration" || itemName == "dashboard" || itemName == "details-dashboard" 
      || (itemName == "paper-work" && email == "AtlantisManagement"))) {
      return true;
    }

    if( itemName == "take-order"){
      let allowOrderFromPortal = localStorage.getItem("allowOrderFromPortal") == "true";
      if(allowOrderFromPortal){
        return true;
      }
    }

    if( itemName == "tank-inventory"){
      let allowOrderFromPortal = localStorage.getItem("allowOrderFromPortal") == "true";
      if(allowOrderFromPortal){
        return true;
      }
    }
    // && 
    // if((role == 'ROLE_STATION_INVENTORY' && itemName == "stationInventory")){
    // if(this.user.user.email == "dispatch@prestigewash.com" && itemName == "stationInventory"){
    //   return true;
    // }
    let found = false;
    if(this.modules && this.modules.length > 0){
      this.modules.forEach(module => {
        if(module.userModuleName == "Inventory Controls"){
          found = true;
        }
      })
    }
    if(itemName == "stationInventory" && found){
      return true;
    }

    return false;


  }

  menuopen(menu: string) {
    this.mybusiness = false;
    this.newbusiness = false;
    this.linkedbusiness = false;
    this.waitinglist = false;

    this.activeMenu = menu;

    localStorage.setItem("activemenu", this.activeMenu);
    if (menu == "other") {
      this.other = !this.other;
    } else if (menu == "mybusiness") {
      this.mybusiness = !this.mybusiness;
    } else if (menu == "linkedbusiness") {
      this.linkedbusiness = !this.linkedbusiness;
    } else if (menu == "waitinglist") {
      this.waitinglist = !this.waitinglist;
    } else if (menu == "administration") {
      this.administration = !this.administration;
    } else if (menu == "statitioninventory") {
      this.statitionInventory = !this.statitionInventory;
    } else if (menu === 'fleetstatus') {
      this.fleetstatus = !this.fleetstatus;
    } else if(menu === 'dispatchLite') {
      this.dispatchLite = !this.dispatchLite;
    }
  }

  submenuopen(menu: string) {
    this.submenu = menu;
    localStorage.setItem("submenu", this.submenu);
  }
  submenulinkedopen(menu: string) {
    this.submenulinked = menu;
    localStorage.setItem("submenulinked", this.submenulinked);
  }

  isLinkActive(url: string): boolean {
    var tempUrl = this.route.snapshot.url.toString();
    if (url.includes("|")) {
      var temp = url.split("|");
      for (var i = 0; i < temp.length; i++) {
        if (tempUrl.includes(temp[i])) {
          return tempUrl.includes(temp[i]);
        }
      }
    } else {
      return tempUrl.includes(url);
    }
  }
}
